import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {CustomDateConverter} from '../../../../../common/custom-date/entity/converter/custom-date.converter';
import {MedicalRecordProblemModel} from '../model/medicalRecordProblem.model';
import {Injectable} from '@angular/core';
import {
    LovValueOrCustomValueConverter
} from '../../../../../common/lov/lov-value/api/converter/LovValueOrCustomValue.converter';

@Injectable({providedIn: 'root'})
export class MedicalRecordProblemConverter extends HttpModelConverter<MedicalRecordProblemModel>{

    constructor(private lovValueOrCustomValueConverter: LovValueOrCustomValueConverter) {
        super();
    }
    protected createInstance(): MedicalRecordProblemModel {
        return new MedicalRecordProblemModel();
    }

    protected enrichObject(result: MedicalRecordProblemModel, src: MedicalRecordProblemModel) {
        const lovValueSummaryConverter: LovValueSummaryConverter = new LovValueSummaryConverter();
        const customDateConverter: CustomDateConverter = new CustomDateConverter();
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.type = lovValueSummaryConverter.convert(src.type);
        result.from = customDateConverter.convert(src.from);
        result.to = customDateConverter.convert(src.to);
        result.locations = this.lovValueOrCustomValueConverter.convertFromArray(src.locations);
        result.whens = this.lovValueOrCustomValueConverter.convertFromArray(src.whens);
    }
}
